import React from 'react';
import TranslateContext from './TranslateContext';

const Translate = props => {
  const { value, context } = props;
  return (
    <TranslateContext.Consumer>
      {translate => translate(value, context || props)}
    </TranslateContext.Consumer>
  );
};

export default Translate;
